import React, { useEffect } from 'react';
import { useMessages } from '../contexts/MessageContext';
import { Grid, makeStyles } from '@material-ui/core';
import MessageList from '../components/MessageList';
import MessageDetail from '../components/MessageDetail';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    listContainer: {
        height: 'calc(100vh - 128px)',
        overflow: 'auto',
    },
    detailContainer: {
        height: 'calc(100vh - 128px)',
        padding: theme.spacing(2),
    },
}));

const InboxPage = () => {
    const classes = useStyles();
    const { fetchMessages } = useMessages();

    useEffect(() => {
        fetchMessages();
    }, [fetchMessages]);

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4} className={classes.listContainer}>
                    <MessageList />
                </Grid>
                <Grid item xs={12} md={8} className={classes.detailContainer}>
                    <MessageDetail />
                </Grid>
            </Grid>
        </div>
    );
};

export default InboxPage;